import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { RouteInfo } from "@/model/RouteInfo";

export interface RouteState {
  routeState: RouteInfo[];
}

const actions: ActionTree<RouteState, any> = {
  setState(
    { commit }: ActionContext<RouteState, any>,
    payload: RouteInfo
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<RouteState, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: RouteState, payload: { data: RouteInfo; index: number }) {
    state.routeState[payload.index] = { ...payload.data };
  },
  clearState(state: RouteState) {
    Object.assign(state, { routeState: [{}, {}, {}, {}, {}, {}, {}] });
  }
};

const getters: GetterTree<RouteState, any> = {
  hasState: (state: RouteState) => (index: number) => {
    return Object.keys(state.routeState[index]).length > 0;
  },
  currentState: (state: RouteState) => (index: number) => {
    return state.routeState[index];
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: {
    routeState: [{}, {}, {}, {}, {}, {}, {}, {}]
  },
  getters,
  actions,
  mutations
};
